var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"webinar"},[_c('v-radio',{class:{ active: _vm.isSelected },attrs:{"label":_vm.webinarDuration,"value":_vm.webinar.webinar_id,"color":"#5FD068","active-class":"active"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }